import { css } from '@emotion/react';

import { MediaBP as MQ } from 'src/styles/mediaQuery';
export const chevStyle = (
  direction: string,
  isSearchLanding: boolean | undefined
) => css`
  background: transparent;
  position: absolute;
  top: 0;
  bottom: 0;
  ${MQ.MediaLg} {
    ${isSearchLanding
      ? `${direction == 'left' ? 'left: -10px;' : 'right: -10px;'}`
      : `${direction == 'left' ? 'left: -40px;' : 'right: -40px;'}`}
  }
  ${MQ.MediaXl} {
    ${isSearchLanding
      ? `${direction == 'left' ? 'left: -60px;' : 'right: -60px;'}`
      : `${direction == 'left' ? 'left: -100px;' : 'right: -100px;'}`}
  }
  background: rgba(0, 0, 0, 0.2);
  width: 43px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  transform: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1;
  border: none;
`;
